<template>
  <div class="chartsection">
    <span class="yxcis">ポイント</span>
    <CChartLine :datasets="defaultDatasets" :options="defaultOptions" :labels="getPointId()" />
    <span class="xxcis ">回</span>
  </div>
</template>

<script>
import axios from "axios";
import { CChartLine } from "@coreui/vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils/src";

export default {
  name: "MainChartExample",
  components: {
    CChartLine,
  },
  data() {
    return {
      tableItems: [],
      copyItems: [],
    };
  },

  methods: {
    getRecords: function () {
      //Get current user ポイント更新履歴
      var urlRequest = "/rest/currentuser/points/history";
      this.loading = true;
      axios({
        url: urlRequest,
        method: "GET",
        headers: { Authorization: `Bearer ${this.$keycloak.token}` },
      })
        .then((resp) => {
          this.tableItems = resp.data;
          //console.log(resp)
          console.log(this.tableItems2);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
     },

    pointsAfterData: function () {
      const pointsAfter = [];
      for (let i = 0; i < this.tableItems.length; i++) {
        pointsAfter.push(this.tableItems[i].pointsAfter);
      }     
      return pointsAfter;
    },
    gotMaxvalue: function () {
      const pointsAfter = [];
      for (let i = 0; i < this.tableItems.length; i++) {
        pointsAfter.push(this.tableItems[i].pointsAfter);
      }
      return Math.max.apply(null, pointsAfter);
    },
    pointsBeforeData: function () {
      const pointsBefore = [];
      for (let i = 0; i < this.tableItems.length; i++) {
        pointsBefore.push(this.tableItems[i].pointsBefore);
      }
      return pointsBefore;
    },
    pointsWithDirectionData: function () {
      const pointsWithDirection = [];
      for (let i = 0; i < this.tableItems.length; i++) {
        pointsWithDirection.push(this.tableItems[i].pointsWithDirection);
      }
      return pointsWithDirection;
    },
    getPointId: function(){
      const id = [];
      for (let i = 0; i < this.tableItems.length; i++) {
        id.push(this.tableItems[i].id);
      }
      return id;
    },
    createdDateData: function () {
      const createdDate = [];
      for (let i = 0; i < this.tableItems.length; i++) {
        const oiDate = new Date(this.tableItems[i].createdDate);
        const ye = new Intl.DateTimeFormat("ja-JP", { year: "2-digit" }).format(
          oiDate
        );
        const mo = new Intl.DateTimeFormat("ja-JP", { month: "short" }).format(
          oiDate
        );
        createdDate.push(ye + mo);
      }
      return createdDate;

      // new Date(item.createdDate) | dateFormat('YY-MM-DD HH:mm')
    },
  },
  computed: {
    defaultDatasets() {
      const brandSuccess = getStyle("success2") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";

      // let elements = this.tableItems.length;
      const data1 = this.pointsAfterData();
      const data2 = this.pointsBeforeData();
      const data3 = this.pointsWithDirectionData();

      return [
        {
          label: "更新後",
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: data1,
        },
        {
          label: "更新前",
          backgroundColor: "transparent",
          borderColor: brandSuccess,
          pointHoverBackgroundColor: brandSuccess,
          borderWidth: 2,
          data: data2,
        },
        {
          label: "更新値",
          backgroundColor: "transparent",
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 1,
          borderDash: [8, 5],
          data: data3,
        },
      ];
    },
    defaultOptions() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(this.gotMaxvalue() / 4),
                max: this.gotMaxvalue(),
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
          },
        },
      };
    },
  },
  beforeMount() {
    this.getRecords();
  },
};
</script>

<style lang="scss">
canvas {
  height: 300px !important;
}
</style>
